var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('logo-header-layout',{attrs:{"align":"center","flex":""}},[_c('payment-process-card',{attrs:{"title":_vm.paymentStatus === 1 
        ? _vm.$t('message.payment.already-processed')
        : _vm.$t('message.payment.process'),"subTitle":_vm.paymentStatus === 1 
        ? _vm.$t("message.payment.msg-success")
        : _vm.$t('message.payment.redirect')}},[(_vm.paymentStatus !== 1)?_c('div',{attrs:{"id":"paymentForm"}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }